import type { MaterialsView } from '../../../deck/materials';
import { SegmentedControl } from '../../components/SegmentedControl';
import { Grid2x2, List } from '../../icons';
import type { MaterialsViewToggleProps } from './DeckMaterials.types';

/**
 * The overview's grid / list switch — the same two icon segments the deck
 * list's `DeckFilterPanel` uses, so a view toggle looks the same wherever a
 * surface has two layouts. Where a pane has a header it sits at that header's
 * right end (web, the iPad). The phone's pane has none, so the phone offers
 * the same choice from the screen's ⋯ menu instead and draws no switch.
 *
 * `s` matches the materials bar's 42px track beside it
 * (32px cell + 4px padding + 1px border each side).
 */
export function MaterialsViewToggle({
  value,
  onChange,
  gridLabel,
  listLabel,
  size = 's',
  className,
  testID,
}: MaterialsViewToggleProps) {
  return (
    <SegmentedControl<MaterialsView>
      size={size}
      value={value}
      onValueChange={onChange}
      className={className}
      items={[
        {
          value: 'grid',
          icon: Grid2x2,
          accessibilityLabel: gridLabel,
          testID: testID ? `${testID}-grid` : undefined,
        },
        {
          value: 'list',
          icon: List,
          accessibilityLabel: listLabel,
          testID: testID ? `${testID}-list` : undefined,
        },
      ]}
    />
  );
}
(MaterialsViewToggle as { displayName?: string }).displayName = 'MaterialsViewToggle';
